<template>
  <div class="LayoutShared">
    <RouterView />
  </div>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss">
.LayoutShared {
  min-height: 100vh;
  width: 100%;
  margin: 0;
  padding: 0;
}
</style>
